// extracted by mini-css-extract-plugin
export default {"bubble":"ScheduleBubble_bubble__xdGvK","bubbleTitle":"ScheduleBubble_bubbleTitle__jgslC","bubbleSubtitle":"ScheduleBubble_bubbleSubtitle__jPCKK"};